function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.64286 6.89286H20.3571C20.7122 6.89286 21 6.60506 21 6.25V4.64286C21 4.2878 20.7122 4 20.3571 4H3.64286C3.2878 4 3 4.2878 3 4.64286V6.25C3 6.60506 3.2878 6.89286 3.64286 6.89286ZM3.64286 13.3214H20.3571C20.7122 13.3214 21 13.0336 21 12.6786V11.0714C21 10.7164 20.7122 10.4286 20.3571 10.4286H3.64286C3.2878 10.4286 3 10.7164 3 11.0714V12.6786C3 13.0336 3.2878 13.3214 3.64286 13.3214ZM3.64286 19.75H20.3571C20.7122 19.75 21 19.4622 21 19.1071V17.5C21 17.1449 20.7122 16.8571 20.3571 16.8571H3.64286C3.2878 16.8571 3 17.1449 3 17.5V19.1071C3 19.4622 3.2878 19.75 3.64286 19.75Z",
  fill: "#424240"
});

var SvgBurger = function SvgBurger(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBurger, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Burger.9b1c67d7.svg";
export { ForwardRef as ReactComponent };